import { Flex, Text } from '@mantine/core'
import { useContext, useEffect, useState } from 'react'
import SingleCustomerContext from '../../Customer-Context/SingleCustomerContext'
import { LIGHT_BLUE_BACKGROUND } from '../../../../constants/colors';
import { capitalizeFirstLetter } from '../../../../utils/capitalizeFirstLetter';

const SegmentAttributes = () => {

  const [localFilters, setLocalFilters] = useState<any[]>([]);

  const { activeFilters } = useContext(SingleCustomerContext)

  useEffect(() => {

    setLocalFilters(activeFilters);
  }, [activeFilters]);

  return (
    <Flex>
      {localFilters.map((filter: any, index: number) => {
        const filterName = capitalizeFirstLetter(filter?.type)
        const filterValues = filter?.values
        return (
          <Flex 
            key={`${filter?.type}-${index}`}
            bg={LIGHT_BLUE_BACKGROUND} 
            px={8} 
            py={4} 
            style={{ borderRadius: 4 }}
            ml={8}
          >
            <Text mr={4}>{filterName}:</Text>
            {filterValues.map((value: any, valueIndex: number) => (
              <Text key={`${filter?.type}-${value}-${valueIndex}`} mr={4}>
                {capitalizeFirstLetter(value)}
                {valueIndex < filterValues.length - 1 && ','}
              </Text>
            ))}
          </Flex>
        )
      })}

    </Flex>
  )
}

export default SegmentAttributes